import { IsArray, IsBoolean, IsInt, IsOptional, IsString, Matches, MaxLength, ValidateNested, ValidateIf, isDefined, IsDefined } from 'class-validator';

import { NomenclatureTypeChildUpdateParameterRequest } from './nomenclature-type-child-update-parameter.request';

export class NomenclatureTypeChildUpdateRequest {
    @ValidateIf(
        (o: NomenclatureTypeChildUpdateRequest) => isDefined(o.id) || !isDefined(o.nomTypeUuidParent) || !isDefined(o.nomTypeUuidChild) || !isDefined(o.name)
    )
    @IsDefined({ message: '"id" is required when one of "nomTypeUuidParent", "nomTypeUuidChild", "name" is not set' })
    @IsInt()
    public id?: number;

    @ValidateIf((o: NomenclatureTypeChildUpdateRequest) => isDefined(o.nomTypeUuidParent) || !isDefined(o.id))
    @IsDefined({ message: '"nomTypeUuidParent" is required when "id" is not set' })
    @IsString()
    public nomTypeUuidParent?: string;

    @ValidateIf((o: NomenclatureTypeChildUpdateRequest) => isDefined(o.nomTypeUuidChild) || !isDefined(o.id))
    @IsDefined({ message: '"nomTypeUuidChild" is required when "id" is not set' })
    @IsString()
    public nomTypeUuidChild?: string;

    @ValidateIf((o: NomenclatureTypeChildUpdateRequest) => isDefined(o.name) || !isDefined(o.id))
    @IsDefined({ message: '"name" is required when "id" is not set' })
    @IsString()
    @MaxLength(255)
    @Matches(
        /^[a-zA-Z_0-9]+$/,
        { message: 'Машинное имя должно содержать только буквы латинского алфавита, цифры и символы подчёркивания' }
    )
    public name: string;

    @IsOptional()
    @IsString()
    public title?: string;

    @IsOptional()
    @IsString()
    public formulaQuantity?: string;

    @IsOptional()
    @IsBoolean()
    public required?: boolean;

    @IsOptional()
    @IsString()
    public requiredCondition?: string;

    @IsOptional()
    @IsString()
    public usageCondition?: string;

    @IsOptional()
    @IsArray()
    @ValidateNested({ each: true })
    public parameters?: NomenclatureTypeChildUpdateParameterRequest[];

    constructor(data?: Partial<NomenclatureTypeChildUpdateRequest>) {
        this.id = data?.id;
        this.nomTypeUuidParent = data?.nomTypeUuidParent;
        this.nomTypeUuidChild = data?.nomTypeUuidChild;
        this.name = data?.name;
        this.title = data?.title;
        this.formulaQuantity = data?.formulaQuantity;
        this.required = data?.required;
        this.requiredCondition = data?.requiredCondition;
        this.usageCondition = data?.usageCondition;
        this.parameters = Array.isArray(data?.parameters)
            ? data.parameters.map(item => new NomenclatureTypeChildUpdateParameterRequest(item))
            : data?.parameters;
    }
}
